import { useState } from "react";
import { Pressable } from "react-native";
import { Icon } from "@ant-design/react-native";
import { Text } from "@shared/components/text";
import { colorPalette } from "@shared/config/colorsConfig";
import { dynamicTranslations } from "@shared/utils/dynamicTranslation";
import { useComplianceScores, usePathwayId } from "app/_modules/pathways";
import { AdherenceInfoModal } from "./AdherenceInfoModal";

export const AdherenceCard = () => {
    const { t } = dynamicTranslations();
    const [visible, setVisible] = useState(false);
    const pathwayId = usePathwayId();
    const { data: complianceScores } = useComplianceScores(pathwayId);

    return (
        <>
            <Pressable
                onPress={() => setVisible(true)}
                className="flex-1 flex-row items-center gap-3 border border-gray-300 bg-white rounded-2xl px-4 py-3"
            >
                <Text className="font-bold text-secondary-600 text-lg bg-secondary-100 rounded-xl px-3.5 py-2">
                    {`${Math.round(complianceScores?.overall ?? 0)}%`}
                </Text>
                <Text className="flex-1 font-semibold text-base">{t('screens.activities.adherence.title')}</Text>
                <Icon name="right" size={18} color={colorPalette.gray[500]} />
            </Pressable>

            <AdherenceInfoModal visible={visible} onClose={() => setVisible(false)} />
        </>
    );
};

export default AdherenceCard;
